import axios from "axios";
import config from "@Config/index";

interface HelpfulResponse {
  success: boolean;
  helpfulCount?: number;
  message?: string;
}

/**
 * Marks a review as "helpful" (anonymous, rate-limited).
 * Posts to the backend API scoped under the inventory.
 */
const markReviewHelpful = async (
  inventoryId: string | number,
  reviewId: string,
): Promise<HelpfulResponse> => {
  const response = await axios.post(
    `${config.API_URL}/api/v0/inventories/${inventoryId}/reviews/${reviewId}/helpful`,
    {},
    { withCredentials: true, ...config.apiParams },
  );
  return { success: true, helpfulCount: response?.data?.data?.helpful_count };
};

export default markReviewHelpful;
